module.exports = __webpack_public_path__ + "static/img/login_pic.1fbe7de.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/login_pic.png
// module id = cKdi
// module chunks = 0